/**
 * Constants for rendering a RequestItem.
 */

export const requestTypes = [
  { id: 'NONE', name: 'Select a request type:' },
  { id: 'ACCOUNT_CONNECT', name: 'Account Connect' },
  { id: 'CATEGORIZATION', name: 'Categorization Request' },
  { id: 'DOCUMENT_UPLOAD', name: 'Document Upload' },
  { id: 'GENERAL', name: 'General Request' },
] as const;

export type RequestType = (typeof requestTypes)[number]['id'];

export const requestTypeLabels = {
  ACCOUNT_CONNECT: 'Account Connect Request',
  CATEGORIZATION: 'Categorization Request',
  DOCUMENT_UPLOAD: 'Document Request',
  GENERAL: 'General Request',
} as const;

export const requestTypeLinkUrl = {
  ACCOUNT_CONNECT: 'accounts/connections',
  CATEGORIZATION: 'categorize',
  DOCUMENT_UPLOAD: 'documents/uploads',
  GENERAL: '',
} as const;

export const serviceBubbleTypes = {
  ACCOUNT_CONNECT: 'AccountConnectionRequest',
  CATEGORIZATION: 'CategorizationRequest',
  DOCUMENT_UPLOAD: 'DocumentRequest',
  GENERAL: 'GeneralRequest',
} as const;
